import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

export default class Pagination extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.state = {
      currentPage: props.currentPage,
      invalid: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.currentPage !== nextProps.currentPage) {
      this.setState({
        currentPage: nextProps.currentPage,
      });
    }
  }

  /* Handlers */

  pageChangeHandler(newPage) {
    let invalid = false;

    if (!isNaN(newPage) && newPage <= this.props.amountPages && newPage >= 1) {
      this.props.onChange(newPage);
    } else {
      invalid = true;
    }

    this.setState({
      currentPage: newPage,
      invalid,
    });
  }

  /* Render */

  render() {
    const inputClassNames = classNames('input', 'input__native', 'u-text-center', { 'is-invalid': this.state.invalid });

    return (
      <div className="pagination">
        <div className="align align--fluid align--gutter-md">
          <div className="align__cell align__cell--shrink">
            <button
              className="button button-text button-text--sm"
              onClick={() => this.pageChangeHandler(this.state.currentPage - 1)}
              disabled={this.state.currentPage <= 1}
            >
              <span className="icon icon-chevron-left icon--xs icon--position-left" />
              <FormattedMessage id="components.pagination.previousPage" />
            </button>
          </div>
          <div className="align__cell">
            <div className="align align--centered align--gutter-xs">
              <div className="align__cell">
                <FormattedMessage id="components.pagination.page" />
              </div>
              <div className="align__cell">
                <input
                  className={inputClassNames}
                  max={this.props.amountPages}
                  min={1}
                  onChange={event => this.pageChangeHandler(parseInt(event.target.value, 10))}
                  type="number"
                  value={this.state.currentPage}
                />
              </div>
              <div className="align__cell">
                <FormattedMessage id="components.pagination.of" />
              </div>
              <div className="align__cell">
                {this.props.amountPages}
              </div>
            </div>
          </div>
          <div className="align__cell align__cell--shrink">
            <button
              className="button button-text button-text--sm"
              onClick={() => this.pageChangeHandler(this.state.currentPage + 1)}
              disabled={this.state.currentPage >= this.props.amountPages}
            >
              <FormattedMessage id="components.pagination.nextPage" />
              <span className="icon icon-chevron-right icon--xs icon--position-right" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Pagination.defaultProps = {
  amountPages: 10,
  currentPage: 1,
};

Pagination.propTypes = {
  amountPages: PropTypes.number,
  currentPage: PropTypes.number,
  onChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/pagination/index.jsx